/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { SourceService } from '../../services/source.service';
import { GlobalMessageService } from '../../services/global-message.service';

@Component({
  selector: 'source-picker',
  templateUrl: './source-picker.component.html'
})
export class SourcePickerComponent implements OnInit {

  @Input()
  selectedSources: any[] = [];

  @Input()
  options: SourcePickerOptions;

  @Output('onChange')
  onChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('sourceDialog') sourceDialog: TemplateRef<any>;

  // so we can close on new
  @ViewChild('sourceDD') sourceDD;

  sourceDialogRef: BsModalRef;

  sources: any[] = [];
  sourceDDSettings: any = {
    text: 'Select source(s)',
    unSelectAllText: 'Remove all',
    enableSearchFilter: true,
    badgeShowLimit: 0
  };

  newSourceLabel: string = '[ Add New Source ]';
  newSource: string = '';

  constructor(private sourceService: SourceService,
    private globalMessageService: GlobalMessageService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.sourceDDSettings.badgeShowLimit = this.options.badgeShowLimit;
    this.sourceService.getSources(this.options.minimumCount).subscribe(
      (result: any) => {
        this.initSources(result);
      },
      error => {

      }
    )
  }

  sourceChange() {
    this.sourceChangeInternal();
  }

  /**
   * When selecting all, we need to remove the "Add New Source" option to keep the control consistent
   */
  sourceAll() {
    let newIndex = this.selectedSources.findIndex(i => { return i.id == 'new' });
    if (newIndex >= 0) {
      this.selectedSources.splice(newIndex, 1);
    }

    newIndex = this.sources.findIndex(i => { return i.id == 'new' });
    if (newIndex >= 0) {
      this.sources.splice(newIndex, 1);
    }
    this.sourceChangeInternal();
  }

  /**
   * Need to add the "Add New Source" option back in
   */
  sourceRemoveAll() {
    this.sources.unshift({
      id: 'new', itemName: this.newSourceLabel
    });
    this.sourceChangeInternal();
  }

  addSource() {
    this.sourceDialogRef.hide();
    let existingIndex = this.sources.findIndex(s => { return s.itemName == this.newSource });
    if (existingIndex >= 0) {
      // duplicate source - just select it and move on
      this.selectedSources.push(this.sources[existingIndex]);
      this.sourceChangeInternal();
      this.globalMessageService.message('Existing source was found in your account and automatically selected');
      this.newSource = '';
    }
    else {
      // new source - save, refresh, and select the newly added source
      this.sourceService.saveSource(this.newSource).subscribe(
        (result: any) => {
          this.sources.push({
            id: result._id,
            itemName: result.email_address
          });
          this.sortSources();
          let newIndex = this.sources.findIndex(s => { return s.itemName == this.newSource });
          this.selectedSources.push(this.sources[newIndex]);
          this.sourceChangeInternal();
          this.globalMessageService.message('New source was saved and automatically selected');
          this.newSource = '';
        },
        error => {

        }
      )
    };
  }

  private sourceChangeInternal() {
    let newIndex = this.selectedSources.findIndex(i => { return i.id == 'new' });
    let expectedLength = this.sources.length;
    if (this.options.allowAdd && newIndex >= 0) {
      expectedLength -= 1;
    }

    if (this.selectedSources.length == expectedLength) {
      this.onChange.emit([]);
    }
    else {
      if (newIndex >= 0) {
        // close the dropdown and pop the add dialog
        this.sourceDD.closeDropdown();
        this.selectedSources.splice(newIndex, 1);
        this.sourceDialogRef = this.modalService.show(this.sourceDialog);
      }
      else {
        this.sortSources();
        this.onChange.emit(this.selectedSources);
      }
    }
  }

  private initSources(src: any) {
    this.sources = src.map(s => {
      return { id: s._id, itemName: (s.email_address.length > this.options.concatLength ? (s.email_address.substring(0, this.options.concatLength - 3) + '...') : s.email_address) };
    });

    if (this.options.allowAdd) {
      this.sources.unshift({
        id: 'new', itemName: this.newSourceLabel
      });
    }

    this.sortSources();
  }

  private sortSources() {
    this.sources.sort((a, b) => {
      if (a.id == this.newSourceLabel) {
        return 1;
      }
      else if (a.itemName > b.itemName) {
        return 1;
      }
      else {
        return -1;
      }
    });

    this.selectedSources.sort((a, b) => {
      if (a.itemName > b.itemName) {
        return 1;
      }
      else {
        return -1;
      }
    });
  }
}

export interface SourcePickerOptions {
  badgeShowLimit: number;  // how many items to show as badges in the control
  required: boolean;       // require at least one to be selected
  default: {
    include: string[],
    exclude: string[]
  }      // default selection
  allowAdd: boolean;       // allow "New Source" functionality
  minimumCount: number;    // minimum count for sources to display
  concatLength: number;    // maximum length to allow for sources
}



// WEBPACK FOOTER //
// ./client/app/global/source-picker/source-picker.component.ts